import { ReactNode } from 'react';
import { cx } from '~/common/utils';

type Props = {
  children: ReactNode;
  className?: string;
};

export const SmallPagePaper = ({ children, className }: Props) => (
  <div
    className={cx(
      'flex def:items-center justify-center bg-other-100 md:py-6 text-text-500 grow',
      className,
    )}
  >
    <div className="w-[440px] max-w-full md:border border-solid border-other-300 rounded-md bg-text-100 px-3 py-3 font-brand-b1">
      {children}
    </div>
  </div>
);
